var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import storageService from '../../utils/storageService';
// TODO: remove this once backend user settings endpoint is available.
var selectedOrganizationIdKey = 'selectedOrganizationId';
var PREV_SELECTED_ORGANIZATION_LIST_OBJECT = 'PREV_SELECTED_ORGANIZATION_LIST_OBJECT';
// if stored organizationId is available, cross-check it with the current list of organizations, set it to
// false if the selected organization is no longer available
export var getSelectedOrganizationId = function (organizations) {
    var storedOrganizationId = storageService.getItem(selectedOrganizationIdKey) || '';
    if (storedOrganizationId) {
        if (organizations && organizations.length) {
            if (storedOrganizationId !== 'shared' &&
                !organizations.some(function (org) { return org.id === storedOrganizationId; })) {
                storedOrganizationId = '';
            }
        }
    }
    return storedOrganizationId;
};
export var getRecentSelectedOrganizationIds = function (userId) {
    var _a, _b;
    if (storageService.getItem(PREV_SELECTED_ORGANIZATION_LIST_OBJECT)) {
        return (_b = (((_a = JSON.parse(storageService.getItem(PREV_SELECTED_ORGANIZATION_LIST_OBJECT) || {})) === null || _a === void 0 ? void 0 : _a[userId]) || [])) === null || _b === void 0 ? void 0 : _b.filter(function (id) { return id !== 'shared'; });
    }
    return [];
};
export var setRecentlySelectedOrgIds = function (orgId, userId) {
    var _a;
    localStorage.setItem(PREV_SELECTED_ORGANIZATION_LIST_OBJECT, JSON.stringify((_a = {},
        _a[userId] = __spreadArray([
            orgId
        ], getRecentSelectedOrganizationIds(userId).filter(function (id) { return id !== orgId; }), true).slice(0, 5),
        _a)));
};
export var storeSelectedOrganizationId = function (organizationId) {
    storageService.setItem(selectedOrganizationIdKey, organizationId);
};
